/**
 * Created by Ivan on 31.07.2024
 */

const RewardStickerView = cc.Node.extend({
    ctor: function (sticker) {
        this._super();
        const ViewClass = sticker.getViewClass();
        const stickerView = this.stickerView = new ViewClass(sticker);
        stickerView.setAnchorPoint(0.5, 0.5);

        this.setAnchorPoint(0.5, 0);
        this.setVisible(false);
        this.setCascadeOpacityEnabledRecursively(true);
        this.setContentSize2(stickerView.getContentSize());
        this.addChild(stickerView);
        stickerView.setAlignment(this.width / 2, this.height / 2);

        if (this.stickerView.sticker.duplicate) {
            const duplicateLabel = this.duplicateLabel = cleverapps.UI.generateOnlyText(Messages.get("Duplicate.Text"), cleverapps.styles.FONTS.DUPLICATE_TEXT);
            this.addChild(duplicateLabel);
            duplicateLabel.setAlignment(cleverapps.styles.StickerView.text);
            duplicateLabel.setVisible(false);

            if (cleverapps.styles.RewardStickerView.replaceWithDuplicateImage) {
                const jokerIcon = new cc.Sprite(bundles.stickers_reward_window.frames.joker_icon_png);
                this.stickerView.addChild(jokerIcon);
                jokerIcon.setAlignment(this.width / 2, this.height / 2);

                this.stickerView.image.setVisible(false);

                if (this.stickerView.stars) {
                    this.stickerView.stars.setVisible(false);
                }
            }
        } else {
            this.stickerView.createBadge();
            this.stickerView.badge.setVisible(false);
        }
    },

    receiveStickerAnimation: function (delay) {
        delay = delay || 0;

        this.targetPosition = this.getPosition();
        this.runAction(new cc.Sequence(
            new cc.Hide(),
            new cc.DelayTime(delay),
            StandartAnimations.showUp(this),
            new cc.CallFunc(() => {
                this.stickerView.ray = StandartAnimations.rays(this.stickerView, { skin: "blue" });
                this.stickerView.ray.setLocalZOrder(-1);
                this.stickerView.ray.replaceParentSamePlace(this.getParent(), {
                    keepScale: true
                });
            }),
            new cc.Spawn(
                new cc.CallFunc(() => {
                    this.duplicateLabel ? this.showDuplicate() : this.showBadge();
                }),
                new cc.DelayTime(0.4)
            ),
            new cc.DelayTime(1.5),
            new cc.CallFunc(() => {
                if (this.stickerView.ray) {
                    this.stickerView.ray.runAction(new cc.Sequence(
                        new cc.Spawn(
                            new cc.FadeOut(0.5),
                            new cc.ScaleTo(0.5, 0.5),
                            new cc.RotateBy(0.5, 45)
                        ),
                        new cc.RemoveSelf()
                    ));
                }
            })
        ));
    },

    finishReceiveAnimation: function () {
        this.stopAllActions();

        this.setVisible(true);
        this.setOpacity(255);
        this.setScale(1);

        if (this.targetPosition) {
            this.setPosition(this.targetPosition);
            this.targetPosition = undefined;
        }
        if (this.stickerAnimation) {
            this.stickerAnimation.removeFromParent();
            this.stickerAnimation = undefined;
        }
        if (this.stickerView.ray) {
            this.stickerView.ray.removeFromParent();
            this.stickerView.ray = undefined;
        }

        this.stickerView.stopAllActions();
        this.stickerView.setVisible(true);

        this.duplicateLabel ? this.showDuplicate(true) : this.showBadge(true);
    },

    collectStickerAnimation: function (callback) {
        this.stickerView.baseScale = (this.stickerView.baseScale || 1) / 1.3;

        this.runAction(new cc.Sequence(
            new cc.ScaleTo(0.1, 1.1),
            new cc.ScaleTo(0.1, 0.7),
            new cc.CallFunc(() => {
                this.stickerView.duplicateLabel && this.stickerView.duplicateLabel.removeFromParent();
            }),
            StandartAnimations.animateCollect(this.stickerView, "stickersBook", {
                adjustToTarget: true,
                collectEffect: true
            }),
            new cc.RemoveSelf(),
            new cc.CallFunc(callback)
        ));
    },

    showDuplicate: function (silent) {
        if (silent) {
            this.duplicateLabel.stopAllActions();
            this.duplicateLabel.setVisible(true);
            this.duplicateLabel.setScale(1);
            return;
        }

        this.duplicateLabel.runAction(new cc.Sequence(
            new cc.ScaleTo(0, 2),
            new cc.Show(),
            new cc.ScaleTo(0.4, 1).easing(cc.easeBackOut())
        ));
    },

    showBadge: function (silent) {
        if (silent) {
            this.stickerView.badge.stopAllActions();
            this.stickerView.badge.setVisible(true);
            this.stickerView.badge.setScale(1);
            return;
        }

        this.stickerView.badge.runAction(new cc.Sequence(
            new cc.ScaleTo(0, 3),
            new cc.Show(),
            new cc.CallFunc(() => {
                cleverapps.effects.fire("stickers.window.new");
            }),
            new cc.ScaleTo(0.2, 1).easing(cc.easeBackOut()),
            new cc.DelayTime(0.2)
        ));
    },

    createAnimation: function () {
        const stickerAnimation = this.stickerAnimation = new cleverapps.Spine(bundles.stickers_reward_window.jsons.collect_sticker_json);
        this.addChild(stickerAnimation);
        stickerAnimation.setAlignment(this.width / 2, this.height / 2);
        stickerAnimation.setLocalZOrder(1000);

        return stickerAnimation;
    }
});

cleverapps.styles.RewardStickerView = {
    collectAnimation: {
        scale: 0.7
    }
};